import { type Message } from '@sunrise-ui/api/messenger';
import { DateTime } from 'luxon';

const ONE_HOUR_IN_SECONDS = 3600;

export const useMessagesGroupedByTime = (messages?: Message[]): Message[][] => {
  if (!messages || messages.length === 0) return [];
  const groupedMessages = [];
  let currentGroup: Message[] = [];

  for (let i = 0; i < messages.length; i++) {
    if (i === 0) {
      // Add the first message to the current group
      currentGroup.push(messages[i]);
    } else {
      const previousMessage = messages[i - 1];
      const currentTime = DateTime.fromISO(messages[i].timestamp ?? '');
      const previousTime = DateTime.fromISO(previousMessage.timestamp ?? '');

      // Calculate the difference in seconds
      const timeDifferenceInSeconds = Math.abs(
        previousTime.diff(currentTime, 'seconds').seconds,
      );

      if (timeDifferenceInSeconds <= ONE_HOUR_IN_SECONDS) {
        // If the time difference is less than or equal to one hour, add to current group
        currentGroup.push(messages[i]);
      } else {
        // Otherwise, start a new group
        groupedMessages.push(currentGroup);
        currentGroup = [messages[i]];
      }
    }
  }

  // Add the last group to the grouped messages
  if (currentGroup.length > 0) {
    groupedMessages.push(currentGroup);
  }

  return groupedMessages;
};
